import { useState } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import './App.css';
import MainMint from './MainMint';
import NavBar from './NavBar';
import Rarities from './Rarities';
import Faq from './Faq';

/*
import Home from './Home';
import Roadmap from './Roadmap';
import Lore from './Lore';
*/

function App() {
  const [accounts, setAccounts] = useState([]);

  return (
    <Router>
      <div className="overlay">
        <div className="App">
          <NavBar accounts={accounts} setAccounts={setAccounts} />
            <div className="content">
              <Switch>
                <Route exact path="/">
                  <MainMint accounts={accounts} setAccounts={setAccounts} />
                </Route>
                <Route path="/rarities">
                  <Rarities accounts={accounts} setAccounts={setAccounts} />
                </Route>
                <Route path="/faq">
                  <Faq accounts={accounts} setAccounts={setAccounts} />
                </Route>

{/*
                <Route exact path="/">
                  <Home accounts={accounts} setAccounts={setAccounts} />
                </Route>
                <Route path="/mint">
                  <MainMint accounts={accounts} setAccounts={setAccounts} />
                </Route>
                <Route path="/roadmap">
                  <Roadmap accounts={accounts} setAccounts={setAccounts} />
                </Route>
                <Route path="/lore">
                  <Lore accounts={accounts} setAccounts={setAccounts} />
                </Route>
                <Route path="/rarities">
                  <Rarities accounts={accounts} setAccounts={setAccounts} />
                </Route>
  */}
              </Switch>
            </div>
          </div>
        <div className="background"></div>
      </div>
    </Router>
  );
};

export default App;